
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenWeatherObservation {

    customersWithoutPower: number;
    timestamp: moment.Moment;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherObservation: GenWeatherObservation);

    constructor( input?: GenWeatherObservation ) {
        if ( input && typeof input !== 'number' ) {
            this.customersWithoutPower = input.customersWithoutPower; // float [number]
            if ( input.timestamp && typeof input.timestamp === 'string' ) {
                this.timestamp = moment(input.timestamp).utc();
            } else {
                this.timestamp = input.timestamp;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherObservation[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherObservation(a));
        } else {
          return [];
        }
    }
}

